import { render, staticRenderFns } from "./aiChatGPT.vue?vue&type=template&id=fe3cc58c"
import script from "./aiChatGPT.vue?vue&type=script&lang=js"
export * from "./aiChatGPT.vue?vue&type=script&lang=js"
import style0 from "./aiChatGPT.vue?vue&type=style&index=0&id=fe3cc58c&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports